<div class="blocedit blocdeco" style="display:block">
  <div class="headedit">
    Veuillez vous reconnecter
  </div>
  <div class="textalert">
    <i class="fal fa-info-circle" style="font-size:40px"></i>
    <br><br>
    Votre session a expiré.
    <br><br>
    Par mesure de securité, veuillez vous reconnecter
    <br>
    en cliquant sur le bonton ci-dessous.
  </div>
  <div class="btnlogalert" routerLink="/login">
    Se connecter
  </div>
</div>
<div class="fdpopedit" style="display:block">
</div>